<template>
  <UApp
    :locale="uiLocale"
    :toaster="toaster"
  >
    <div class="flex min-h-full flex-row bg-gray-100">
      <NuxtLoadingIndicator class="shrink" />
      <div class="min-w-0 grow">
        <NuxtLayout
          :class="{
            'bg-slate-100 bg-pattern': route.path === ROUTE_START_DASHBOARD,
          }"
        >
          <NuxtPage />
        </NuxtLayout>
      </div>
      <PatientSearchPalette />
    </div>
  </UApp>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ROUTE_START_DASHBOARD } from "./constants/routes";
import { en, nl } from "@nuxt/ui/locale";

const { locale } = useI18n();
const route = useRoute();
const toaster = { duration: 5000 };

const uiLocale = computed(() => (locale.value === "nl" ? nl : en));
const { open: openSearch } = useSearchPalette();

useHead({
  titleTemplate: "%s | Verne Health",
  meta: [{ name: "description", content: "Verne Health – De gamechanger voor jou als fysiotherapeut." }],
  htmlAttrs: {
    lang: locale.value ?? "nl",
    dir: "ltr",
  },
});

defineShortcuts({
  meta_k: {
    usingInput: true,
    handler: () => {
      openSearch();
    },
  },
  meta_p: {
    usingInput: true,
    handler: () => {
      navigateTo("/patients/invitation");
    },
  },
});
</script>
